import * as PegParser from './parser/peg-cfi-parser';

class CfiUtils {

  constructor(options) {
    this.pegParser = PegParser;

    // default options
    this.blacklistSelectors = [];

    if (options) {
      if (options.blacklistSelectors) {
        this.blacklistSelectors = options.blacklistSelectors;
      }
    }

    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector;
    }
  }

  sort(cfiArray) {
    if (!Array.isArray(cfiArray)) {
      throw new TypeError('sort only accepts an array.');
    }

    cfiArray.sort((x, y) => {
      return this.compare(x, y);
    });

    return cfiArray;
  }

  compare(xCfi, yCfi) {
    if (xCfi.indexOf('!') >= 0 || yCfi.indexOf('!') >= 0) {
      throw new Error('can only compare partial CFIs');
    }

    // if the cfis are the same, then return equal.
    if (xCfi === yCfi) {
      return 0;
    }

    let x = this.pegParser.parse(xCfi);
    let y = this.pegParser.parse(yCfi);
    let xSteps = x.cfiString.localPath.steps;
    let ySteps = y.cfiString.localPath.steps;

    let shortestCfi = (xSteps.length - ySteps.length >= 0) ? y : x;

    // loop based on smallest cfi and return when the steps diverge.
    for (let i = 0; i < shortestCfi.cfiString.localPath.steps.length; i++) {
      let xStep = parseInt(xSteps[i].stepLength, 10);
      let yStep = parseInt(ySteps[i].stepLength, 10);

      if (xStep - yStep !== 0) {
        return xStep - yStep;
      }
    }

    // if loop completed and they are the same length, check for a character offset.
    if (xSteps.length === ySteps.length) {
      let xOffset = parseInt(x.cfiString.localPath.termStep.offsetValue || -1, 10);
      let yOffset = parseInt(y.cfiString.localPath.termStep.offsetValue || -1, 10);

      return xOffset - yOffset;
    }

    // if no character offset the shorter cfi is a parent to the longer one.
    if (shortestCfi === x) {
      return -1;
    }

    return 1;
  }

  isBlacklisted(element) {
    if (element.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    for (let i = 0; i < this.blacklistSelectors.length; i++) {
      if (element.matches(this.blacklistSelectors[i])) {
        return true;
      }
    }

    let parent = element.parentNode;

    if (parent !== undefined && parent !== null) {
      return this.isBlacklisted(parent);
    }

    return false;
  }

  isValidCfi(cfiString) {
    try {
      this.pegParser.parse(cfiString);
      return true;
    } catch (ex) {
      return false;
    }

  }
}

export default CfiUtils;



// WEBPACK FOOTER //
// ./src/cfi-utils.js